import React from 'react';
import Icon from './icon';
import myTheme from './theme';
import { capitalize } from './global';
import { Link } from 'gatsby';
import '../pages/index.css';

const socials = [
  { name: 'twitter', url: '//twitter.com/jaleung' },
  { name: 'linkedin', url: '//hk.linkedin.com/in/kennyleungdesign' },
  { name: 'behance', url: '//behance.net/jaleung326' },
  { name: 'telegram', url: '//t.me/jaleung' },
];

const Footer = () => {
  let linkColor = myTheme.palette.grey[300];
  let currentYear = new Date().getFullYear();
  return (
    <footer
      style={{ color: linkColor }}
      className="text-center margin-top padding-top"
    >
      <div className="margin-bottom marign-top">
        <Link to="#home">
          <Icon name="down-open" size="1.4" rotate />
        </Link>
      </div>
      <div className="padding">
        {socials.map((social) => (
          <a
            key={social.name}
            title={capitalize(social.name)}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className="padding-left padding-right"
            style={{ color: linkColor }}
          >
            <Icon name={social.name} size="1.2" />
          </a>
        ))}
      </div>
      <div className="padding-bottom">
        <small className="padding-bottom dib">
          © Copyright {currentYear} Kenny Leung. All rights reserved.
        </small>
      </div>
    </footer>
  );
};

export default Footer;
